import { CoolHttp } from '@angular-cool/http';
import { Inject, Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { HelpSiteDataDTO } from '../../../../../common/dto/help-site.dto';
import { DEFAULT_LANGUAGE, Language } from '../../../../../common/dto/languages.dto';
import { Environment } from '../../../environments/environment.interface';
import { SetSiteDataAction } from '../../app.state';
import { HelpSiteService } from './help-site.service';
import { ENVIRONMENT, WINDOW } from './injection-tokens';
import { LoggerService } from './logger/logger.service';


@Injectable()
export class StartupService {
  constructor(
    private _loggerService: LoggerService,
    private _http: CoolHttp,
    private _store: Store,
    private _helpSiteService: HelpSiteService,
    @Inject(ENVIRONMENT) private _environment: Environment,
    @Inject(WINDOW) private _window: Window,
  ) {
  }

  public async setupAsync() {
    this._loggerService.initialize();

    this._setupHttp();

    //Do not wait for load
    this._loadSiteDataAsync();
  }

  private async _loadSiteDataAsync() {
    try {
      const helpSiteData = await this._helpSiteService.getHelpSiteDataAsync(this._getLanguage());

      this._setGlobalsFromSiteData(helpSiteData);

      this._store.dispatch(new SetSiteDataAction(helpSiteData));
    } catch (e: any) {
      this._loggerService.error(e);

      this._window.location.href = this._environment.helpSiteUrl;
    }
  }

  private _setupHttp() {
    this._http.registerBaseUrl(this._environment.serverUrl + '/api');
  }

  private _getLanguage(): Language {
    const url = new URL(this._window.location.href);

    return <Language>url.pathname.match(/^\/?([a-z]{2})(\/.*)?/)?.[1] ?? DEFAULT_LANGUAGE;
  }

  private _setGlobalsFromSiteData(helpSiteData: HelpSiteDataDTO) {
    if (!this._window) {
      return;
    }

    if (helpSiteData.knowledgeBase.favicon) {
      const linkElement = this._window.document.createElement('link');
      linkElement.rel = 'shortcut icon';
      linkElement.href = helpSiteData.knowledgeBase.favicon.url;

      this._window.document.head.appendChild(linkElement);
    }

    if (helpSiteData.knowledgeBase.logo) {
      const ogImageTag = this._window.document.createElement('meta');
      (<any>ogImageTag)['property'] = 'og:image';
      ogImageTag.content = helpSiteData.knowledgeBase.logo.url;

      this._window.document.head.appendChild(ogImageTag);
    }

    if (helpSiteData.knowledgeBase.name) {
      this._window.document.title = helpSiteData.knowledgeBase.name;

      const descriptionMetaElement = this._window.document.createElement('meta');
      descriptionMetaElement.name = 'description';
      descriptionMetaElement.content = helpSiteData.knowledgeBase.name;

      this._window.document.head.appendChild(descriptionMetaElement);
    }

    if (helpSiteData.knowledgeBase.headHTMLContent) {
      this._window.document.head.innerHTML += helpSiteData.knowledgeBase.headHTMLContent;
    }

    if (helpSiteData.knowledgeBase.bodyHTMLContent) {
      this._window.document.body.innerHTML += helpSiteData.knowledgeBase.bodyHTMLContent;
    }
  }
}
